const guard = {
    invalid_input: 'O pedido {{type}} é inválido.',
    invalid_pagination: 'O valor de paginação enviado é inválido.',
    can_not_get_tenant_id: 'Não é possível obter o ID do inquilino a partir do pedido.',
    file_size_exceeded: 'Tamanho do ficheiro excedido.',
    mime_type_not_allowed: 'Tipo MIME não permitido.',
};
export default Object.freeze(guard);
